import aa from "search-insights";

let isAnalyticsInitialized = false;

// Initialize search-insights once, called with keys from the Redux config slice
export function initializeAlgoliaAnalytics(appId: string, apiKey: string): boolean {
  if (isAnalyticsInitialized) {
    return true;
  }
  if (!appId || !apiKey) {
    console.error("Algolia config keys not found in Redux store");
    return false;
  }
  try {
    aa("init", { appId, apiKey });
    isAnalyticsInitialized = true;
    return true;
  } catch (error) {
    console.error("Failed to initialize Algolia analytics:", error);
    return false;
  }
}
